import { z } from 'zod';

// ---------------------------------------------------------------------------
// asset_public_token — fleet-qr-compliance PR3 (design.md §4.1). Admin
// issue/revoke/view. `token` is returned in plain text (it's stored plain,
// not hashed — a deliberate, confirmed decision, see migration 0109 header)
// so the backoffice can re-render/re-print an existing QR without rotating it.
// ---------------------------------------------------------------------------

export const AssetPublicTokenResponseSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  assetId: z.string().uuid(),
  token: z.string(),
  revokedAt: z.string().datetime().or(z.date()).nullable(),
  createdAt: z.string().datetime().or(z.date()),
});
export type AssetPublicTokenResponse = z.infer<typeof AssetPublicTokenResponseSchema>;
